import classes from "./style.module.css";

const Button = () => {
  return <button type="button" className={classes.button} />;
};

export default Button;
